/** 信息描述 */
const MESSAGE_DESC = {
  /** 无法识别的消息 */
  unsupported: '[无法识别的消息]',
  /** 文本 */
  text: '[文本]',
  /** 富文本 */
  richText: '[富文本]',
  /** 语音 */
  audio: '[语音]',
  /** 文件 */
  file: '[文件]',
  /** markdown */
  markdown: '[MarkDown]',
  /** 图片 */
  picture: '[图片]',
  /** 视频 */
  video: '[视频]',
  /** 表情 */
  sticker: '[表情]',
  /** 聊天记录 */
  history: '[聊天记录]',
  /** 档案消息 */
  roleCard: '[档案消息]',
  /** 涂鸦消息 */
  graffiti: '[涂鸦消息]',
  /** 系统消息 */
  system: '[系统消息]',
};

/** 消息跳转的枚举类型 */
enum EMessageJumpType {
  /** '@我'消息 */
  at,
  /** 未读消息 */
  unread,
}

export { MESSAGE_DESC, EMessageJumpType };
